(() => {
  const AGENCIAS_DAC = {

    "Artigas": [
      "Artigas",
      "Deposito Artigas",
      "Bella Union"
    ],

    "Canelones": [
      "Barros Blancos",
      "Canelones",
      "Ciudad De La Costa Shangrila",
      "El Pinar",
      "La Paz",
      "Las Piedras",
      "Migues",
      "Pando",
      "Parque Del Plata",
      "Progreso",
      "Zona Progreso",
      "Salinas",
      "San Jacinto",
      "San Luis",
      "Ancap San Ramon",
      "Santa Lucia",
      "Tala",
      "Toledo"
    ],

    "Cerro Largo": [
      "Ancap Fraile Muerto",
      "Melo",
      "Rio Branco"
    ],

    "Colonia": [
      "Carmelo",
      "Colonia",
      "Colonia Terminal",
      "Miguelete",
      "Valdense",
      "Conchillas",
      "Juan Lacaze",
      "Nueva Helvecia",
      "Nueva Palmira",
      "Ombues De Lavalle",
      "Rosario",
      "Tarariras"
    ],

    "Durazno": [
      "Ancap Durazno",
      "Deposito Durazno",
      "Durazno",
      "Ancap La Paloma (durazno)",
      "Sarandi Del Yi"
    ],

    "Flores": [
      "Trinidad"
    ],

    "Florida": [
      "25 De Agosto",
      "25 De Mayo",
      "Cardal",
      "Casupa",
      "Terminal Florida",
      "Fray Marcos",
      "Independencia",
      "Sarandi Grande"
    ],

    "Lavalleja": [
      "Batlle Y Ordoñez",
      "Agencia Jose Pedro Varela",
      "Mariscala",
      "Minas",
      "Solis De Mataojo"
    ],

    "Maldonado": [
      "Aigua",
      "Balneario Buenos Aires",
      "La Barra",
      "La Capuera",
      "Maldonado",
      "Maldonado Calle Lussich",
      "Pan De Azucar Dac",
      "Piriapolis",
      "Punta Del Este",
      "San Carlos Dac"
    ],

    "Montevideo": [
      "Cerro",
      "Agencia Perimetral Ruta 5",
      "Av Italia",
      "Ciudad Vieja",
      "Funsa",
      "La Comercial",
      "Mercado Modelo",
      "Millan",
      "Paso Molino",
      "Pocitos",
      "Rondeau",
      "Tres Cruces",
      "Belloni - Piedras Blancas",
      "Ancap Sayago"
    ],

    "Paysandú": [
      "Guichon",
      "Paysandu Herrera",
      "Terminal Paysandu",
      "Quebracho"
    ],

    "Río Negro": [
      "Fray Bentos",
      "Nuevo Berlin",
      "San Javier",
      "Young"
    ],

    "Rivera": [
      "Minas De Corrales",
      "Rivera",
      "Rivera Deposito",
      "Ancap Tranqueras",
      "Vichadero"
    ],

    "Rocha": [
      "Castillos Dac",
      "Cebollati",
      "Chuy",
      "La Coronilla",
      "La Paloma Rocha",
      "Lascano Dac",
      "Punta Del Diablo Dac",
      "Rocha Dac",
      "Velazquez"
    ],

    "Salto": [
      "Salto Cerrito",
      "Salto Terminal"
    ],

    "San José": [
      "Ecilda Paullier",
      "Libertad",
      "Km 61 Puntas De Valdez",
      "Ciudad Del Plata",
      "San Jose Centro",
      "San Jose",
      "Villa Rodriguez"
    ],

    "Soriano": [
      "Cañada Nieto",
      "Cardona",
      "Dolores",
      "Rodo",
      "Deposito Mercedes",
      "Terminal Mercedes",
      "Palmitas",
      "Palo Solo",
      "Pueblo Risso",
      "Santa Catalina"
    ],

    "Tacuarembó": [
      "Caraguata",
      "Paso De Los Toros",
      "San Gregorio",
      "Tacuarembo Deposito",
      "Tacuarembo Terminal",
      "Tambores"
    ],

    "Treinta y Tres": [
      "Cerro Chato",
      "Pueblo Rincon",
      "Santa Clara",
      "Treinta Y Tres",
      "Vergara"
    ]

  };


  function obtenerSelector() {
    return {
      departamento:
        document.getElementById("dac-departamento-drawer"),

      agencia:
        document.getElementById("dac-agencia-drawer"),

      estado:
        document.getElementById("dac-estado-drawer"),

      error:
        document.getElementById("dac-error-drawer"),

      checkout:
        document.getElementById("checkout")
    };
  }


  function bloquearPago() {
    const { checkout } = obtenerSelector();

    if (checkout) {
      checkout.disabled = true;
    }
  }


 function habilitarPago() {
  const { checkout } = obtenerSelector();

  if (checkout) {
    checkout.disabled = false;
    checkout.removeAttribute("disabled");
    checkout.setAttribute("aria-disabled", "false");
    checkout.removeAttribute("data-dac-bloqueado");
  }
}


  function cargarAgencias(departamento, seleccionada = "") {
    const { agencia } = obtenerSelector();

    if (!agencia) return;

    agencia.innerHTML = "";

    if (!departamento || !AGENCIAS_DAC[departamento]) {
      agencia.disabled = true;

      agencia.innerHTML =
        '<option value="">Primero seleccioná un departamento</option>';

      return;
    }

    agencia.disabled = false;

    agencia.innerHTML =
      '<option value="">Seleccioná una agencia</option>';

    AGENCIAS_DAC[departamento].forEach((nombre) => {
      const opcion = document.createElement("option");

      opcion.value = nombre;
      opcion.textContent = nombre;

      if (nombre === seleccionada) {
        opcion.selected = true;
      }

      agencia.appendChild(opcion);
    });
  }


  async function restaurarSeleccion() {
    const elementos = obtenerSelector();

    if (!elementos.departamento || !elementos.agencia) {
      return;
    }

    try {
      const respuesta = await fetch("/cart.js", {
        headers: {
          "Accept": "application/json"
        }
      });

      if (!respuesta.ok) {
        bloquearPago();
        return;
      }

      const carrito = await respuesta.json();
      const atributos = carrito.attributes || {};

      const departamentoGuardado =
        atributos["Departamento DAC"] || "";

      const agenciaGuardada =
        atributos["Agencia DAC"] || "";

      if (
        departamentoGuardado &&
        agenciaGuardada &&
        AGENCIAS_DAC[departamentoGuardado] &&
        AGENCIAS_DAC[departamentoGuardado].includes(agenciaGuardada)
      ) {
        elementos.departamento.value = departamentoGuardado;

        cargarAgencias(
          departamentoGuardado,
          agenciaGuardada
        );

        const actuales = obtenerSelector();

        if (actuales.estado) {
          actuales.estado.style.display = "block";
        }

        if (actuales.error) {
          actuales.error.style.display = "none";
        }

        habilitarPago();
      } else {
        bloquearPago();
      }
    } catch (error) {
      console.error("DAC: error leyendo carrito", error);
      bloquearPago();
    }
  }


  /*
   * DELEGACIÓN DE EVENTOS
   *
   * Este listener vive en document.
   * Aunque Horizon destruya y vuelva a crear
   * el contenido del carrito, sigue funcionando.
   */
  document.addEventListener("change", async (event) => {

    /* Departamento */
    if (event.target.id === "dac-departamento-drawer") {
      const departamento = event.target.value;

      const elementos = obtenerSelector();

      if (elementos.estado) {
        elementos.estado.style.display = "none";
      }

      if (elementos.error) {
        elementos.error.style.display = "none";
      }

      bloquearPago();

      /*
       * NO guardamos todavía en Shopify.
       * Solamente habilitamos las agencias.
       */
      cargarAgencias(departamento, "");

      return;
    }


    /* Agencia */
    if (event.target.id === "dac-agencia-drawer") {
      const elementos = obtenerSelector();

      if (!elementos.departamento || !elementos.agencia) {
        return;
      }

      const departamento = elementos.departamento.value;
      const agencia = elementos.agencia.value;

      if (elementos.estado) {
        elementos.estado.style.display = "none";
      }

      if (elementos.error) {
        elementos.error.style.display = "none";
      }

      bloquearPago();

      if (!departamento || !agencia) {
        return;
      }

      try {
        const respuesta = await fetch("/cart/update.js", {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },

          body: JSON.stringify({
            attributes: {
              "Departamento DAC": departamento,
              "Agencia DAC": agencia
            }
          })
        });

        if (!respuesta.ok) {
          throw new Error("No se pudo guardar DAC");
        }

        const carrito = await respuesta.json();
        const atributos = carrito.attributes || {};

        if (
          atributos["Departamento DAC"] === departamento &&
          atributos["Agencia DAC"] === agencia
        ) {
          /*
           * Horizon puede haber reconstruido el drawer
           * durante la actualización, así que buscamos
           * nuevamente los elementos actuales.
           */
          const actuales = obtenerSelector();

          if (actuales.departamento) {
            actuales.departamento.value = departamento;
          }

          cargarAgencias(departamento, agencia);

          const finales = obtenerSelector();

          if (finales.estado) {
            finales.estado.style.display = "block";
          }

          if (finales.error) {
            finales.error.style.display = "none";
          }

          habilitarPago();
        } else {
          throw new Error("Shopify no confirmó los datos DAC");
        }

      } catch (error) {
        console.error("DAC: error guardando agencia", error);

        const actuales = obtenerSelector();

        if (actuales.estado) {
          actuales.estado.style.display = "none";
        }

        if (actuales.error) {
          actuales.error.style.display = "block";
        }

        bloquearPago();
      }
    }
  });


  /*
   * Cuando el drawer aparece o Horizon modifica
   * el carrito, intentamos restaurar los datos.
   */
  document.addEventListener(
    "shopify:section:load",
    () => setTimeout(restaurarSeleccion, 100)
  );


  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      restaurarSeleccion
    );
  } else {
    restaurarSeleccion();
  }

})();